import { asyncAction } from '@jarvis.oddle/core/tools/redux/action'
import { isObjectEmpty } from '@jarvis.oddle/core/tools/object'
import { postStripeChargesApi } from 'api/fesc/client'
import { createPaymentToken } from 'tools/payment'
import * as C from './constants'

const createPaymentTokenApi = async (payload) => {
  const { token, tokenError } = await createPaymentToken(payload)
  if (!isObjectEmpty(tokenError)) {
    throw tokenError
  }

  return token
}

export const createPaymentTokenAction = asyncAction({
  api: createPaymentTokenApi,
  requestAction: C.CREATE_PAYMENT_TOKEN_REQUEST,
  successAction: C.CREATE_PAYMENT_TOKEN_SUCCESS,
  failureAction: C.CREATE_PAYMENT_TOKEN_FAILURE
})

export const postStripeChargesAction = asyncAction({
  api: postStripeChargesApi,
  requestAction: C.POST_STRIPE_CHARGES_REQUEST,
  successAction: C.POST_STRIPE_CHARGES_SUCCESS,
  failureAction: C.POST_STRIPE_CHARGES_FAILURE
})
